import { useState } from 'react';
import { properties as appProperties } from '../../../AppData';
import AuthProvider from 'providers/authProvider';
import {properties as propertiesCloudConfig} from 'config/Config';

const useStyleResponsive = () => {
  const [isPhoneVersion, setIsPhoneVersion] = useState(false);
  const {checkCloudProperties} = AuthProvider();
  const [nombreConsejeria, setNombreConsejeria] = useState();

  const updateFormat = () => {
    if (window.matchMedia(`(max-width: ${appProperties.NUM_PIX_MOVIL})`).matches) {
      setIsPhoneVersion(true);
    } else {
      setIsPhoneVersion(false);
    }
  };
  const loadInfoCloud = async () => {
    await checkCloudProperties(100);
    let nomConsejeria = propertiesCloudConfig['CONSEJERIA_NOMBRE'];
    setNombreConsejeria(nomConsejeria);
  }

  return { isPhoneVersion, updateFormat, loadInfoCloud, nombreConsejeria };
}

export default useStyleResponsive;